export default {
  appName: 'Dispatch Qore',
  navigation: {
    programs: 'Programs',
    reports: 'Reports',
    dispatching: 'Dispatching',
    management: 'Management',
    dashboard: 'Dashboard',
    dispatchBoard: 'Dispatch Board',
    dispatchControl: 'Dispatch Control',
    customers: 'Customers',
    clients: 'Clients',
    services: 'Services',
    dispatchWorkflows: 'Dispatch Workflows',
    settings: 'Settings',
    policyVerificationHistory: 'Policy Verification',
  }
};
